import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { FormTextField } from "@/components/UiKit"
import type { ReSendToIndividualSchemaFormValues } from "@/screens/Pricing/schema/SendPriceChangeSchema"

const EmailTemplateForm: FC = () => {
  const { control } = useFormContext<ReSendToIndividualSchemaFormValues>()

  return (
    <>
      <Typography variant='subtitle2' className='text-ml font-normal text-gray-900'>
        Email Note
      </Typography>

      <Box className='mt-4 p-4'>
        <Typography variant='body2' className='mb-6'>
          Hello [Customer Name],
        </Typography>

        <FormTextField
          control={control}
          name='emailNote'
          multiline
          rows={5}
          data-testid='pricing.send-form-dialog.email-note-field'
        />

        <Box className='my-6 flex flex-col items-center rounded-md bg-gray-100 p-6'>
          <Typography variant='body2'>Recipient-specific product pricing will appear here.</Typography>
        </Box>

        <Typography variant='body2'>
          Akrochem Corporation appreciates the business you have placed with us in the past. If you have any questions,
          please contact your Technical Sales Representative.
        </Typography>

        <Box className='mt-4'>
          <Typography variant='body2'>Sincerely,</Typography>
          <Typography variant='body2'>Santino DeSimone</Typography>
          <Typography variant='body2'>Product Manager</Typography>
        </Box>
      </Box>
    </>
  )
}

export default EmailTemplateForm
